module.exports = __webpack_public_path__ + "img/eye_closed.a49c352b.svg";